import { useCallback } from 'react';
import { useUpdateTodayFilterTagsMutation } from 'shared/hooks/queries/use-update-today-filter-tags-mutation';

export const useClearTodayFilters = () => {
  const { mutate: updateFilterTags } = useUpdateTodayFilterTagsMutation();

  return useCallback(() => updateFilterTags([]), [updateFilterTags]);
};
